import Button from '@mui/material/Button';

import PonduranceSvgIcon from '@/components/PonduranceSvgIcon';

import type { PonduranceEmailButtonProps } from './PonduranceEmailButton.types';

const PonduranceEmailButton = (props: PonduranceEmailButtonProps) => {
  const { email } = props;

  return (
    <Button
      href={`mailto:${email}`}
      startIcon={<PonduranceSvgIcon />}
      size="small"
      sx={{ margin: '0.20rem 0' }}
      variant="outlined"
    >
      {email}
    </Button>
  );
};

export default PonduranceEmailButton;
